import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

export type TankDto = {
  id: string;
  name: string;
  siteId: string;
  siteName: string;
  productName: string;
  level: number | null;
  maxHeight: number;
  capacity: number;
  unit: string;
  amountFilled: number | null;
  percentFilled: number;
  lastSensorReading: string;
  error?: string | null;
}

const useGetTankLevels = (options?: QueryOptions<TankDto[]>) => {
  const business = useSelectedBusiness();
  return useUserQuery<TankDto[]>(
    { path: `/api/businesses/${business.id}/tankLevels` },
    options
  );
}

export default useGetTankLevels;
